// src/pages/home/ExpertSection.tsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import VideoModal from "../home-Two/videoModal";
import MotoristaPerfilModal from "./MotoristaPerfilModal";
import { t } from "../../lang";

interface PopularDriverDTO {
    id: number;
    nome: string;
    fotoId: number | null;
    mediaNota: number;
    totalReservas: number;
}

const serviceOptions = [{ id: "tuk-tuk", name: t("home.expertSection.serviceName") }];

const ExpertSection = () => {
    const routes = all_routes;
    const BASE_URL = process.env.REACT_APP_API_URL;

    const [selectedService, setSelectedService] = useState("tuk-tuk");
    const [items, setItems] = useState<PopularDriverDTO[]>([]);
    const [loading, setLoading] = useState(false);
    const [selectedDriverId, setSelectedDriverId] = useState<number | null>(null);

    const [showModal, setShowModal] = useState(false);
    const videoUrl = "https://youtu.be/NSAOrGb9orM";
    const videoId = videoUrl.split("youtu.be/")[1];
    const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

    const fetchTukTukDrivers = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${BASE_URL}/motorista/mais-populares?limit=5`);
            setItems(res.data);
        } catch (err) {
            console.error("Erro ao buscar motoristas populares:", err);
            setItems([]);
        } finally {
            setLoading(false);
        }
    };

    const handleServiceClick = (serviceId: string) => setSelectedService(serviceId);

    useEffect(() => {
        if (selectedService === "tuk-tuk") fetchTukTukDrivers();
    }, [selectedService]);

    return (
        <>
            <section className="section experts-section">
                <div className="container">
                    {/* Cabeçalho */}
                    <div className="row justify-content-center">
                        <div className="col-xl-6 col-lg-10 text-center">
                            <div className="section-header mb-4">
                                <h2>
                                    <span className="text-primary text-decoration-underline">
                                        {t("home.expertSection.popularTitle")}
                                    </span>
                                </h2>
                                <p className="sub-title">
                                    {t("home.expertSection.popularSubtitle")}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Filtro de serviço */}
                    <div className="place-nav mb-4">
                        <ul className="nav justify-content-center">
                            {serviceOptions.map((s) => (
                                <li key={s.id}>
                                    <Link
                                        to="#"
                                        className={`nav-link ${selectedService === s.id ? "active" : ""}`}
                                        onClick={() => handleServiceClick(s.id)}
                                    >
                                        {s.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Lista de cards */}
                    {loading ? (
                        <p className="text-center">{t("home.expertSection.loading")}</p>
                    ) : (
                        <div className="row">
                            {items.map((item) => {
                                const fotoUrl = item.fotoId
                                    ? `${BASE_URL}/uploads/${item.fotoId}`
                                    : "assets/img/default-avatar.jpg";

                                return (
                                    <div key={item.id} className="col-md-4 col-lg-3 mb-4">
                                        <div className="card text-center h-100">
                                            <div className="card-img-top mb-2">
                                                <img
                                                    src={fotoUrl}
                                                    alt={item.nome}
                                                    className="img-fluid rounded"
                                                    style={{ height: "200px", width: "100%", objectFit: "cover" }}
                                                    onError={(e) => {
                                                        (e.target as HTMLImageElement).src =
                                                            "/assets/img/users/user-generic.jpg";
                                                    }}
                                                />
                                            </div>
                                            <div className="card-body">
                                                <h6 className="card-title">{item.nome}</h6>

                                                {"mediaNota" in item && (
                                                    <>
                                                        <p className="mb-1">
                                                            ⭐ {item.mediaNota.toFixed(1)} / 5
                                                        </p>
                                                        <p className="mb-2 text-muted" style={{ fontSize: "0.9rem" }}>
                                                            📌 {item.totalReservas}{" "}
                                                            {item.totalReservas !== 1
                                                                ? t("home.expertSection.reservationsPlural")
                                                                : t("home.expertSection.reservationsSingular")}
                                                        </p>
                                                    </>
                                                )}

                                                <button
                                                    className="btn btn-sm btn-primary"
                                                    onClick={() => setSelectedDriverId(item.id)}
                                                >
                                                    {t("home.expertSection.viewProfile")}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </section>

            {/* 🎥 Bloco do vídeo */}
            <div
                className="video-wrap"
                style={{
                    backgroundImage: `url(${thumbnailUrl})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <Link
                    className="video-btn video-effect"
                    to="#"
                    onClick={() => setShowModal(true)}
                >
                    <i className="isax isax-play5"></i>
                </Link>
            </div>
            <VideoModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                videoUrl={videoUrl}
            />
            <MotoristaPerfilModal
                open={selectedDriverId !== null}
                onClose={() => setSelectedDriverId(null)}
                motoristaId={selectedDriverId}
                baseUrl={BASE_URL!}
            />
        </>
    );
};

export default ExpertSection;